var _path, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.591 8.59679H10.8923C9.62766 8.59679 8.59832 7.56812 8.59766 6.30412C8.59766 5.03879 9.62699 4.00946 10.8923 4.00879H13.591C13.867 4.00879 14.091 4.23279 14.091 4.50879C14.091 4.78479 13.867 5.00879 13.591 5.00879H10.8923C10.1783 5.00946 9.59766 5.59012 9.59766 6.30346C9.59766 7.01612 10.179 7.59679 10.8923 7.59679H13.591C13.867 7.59679 14.091 7.82079 14.091 8.09679C14.091 8.37279 13.867 8.59679 13.591 8.59679Z",
    fill: "#2D3958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1963 6.7627H10.9883C10.7123 6.7627 10.4883 6.5387 10.4883 6.2627C10.4883 5.9867 10.7123 5.7627 10.9883 5.7627H11.1963C11.4723 5.7627 11.6963 5.9867 11.6963 6.2627C11.6963 6.5387 11.4723 6.7627 11.1963 6.7627Z",
    fill: "#2D3958"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10823_35769",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.332031 0H14.0911V12.7819H0.332031V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10823_35769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3305 1C2.67717 1 1.33184 2.34533 1.33184 3.99867V8.78333C1.33184 10.4367 2.67717 11.782 4.3305 11.782H10.0932C11.7465 11.782 13.0912 10.4367 13.0912 8.78333V3.99867C13.0912 2.34533 11.7465 1 10.0932 1H4.3305ZM10.0934 12.782H4.3307C2.12603 12.782 0.332031 10.988 0.332031 8.78333V3.99867C0.332031 1.79333 2.12603 0 4.3307 0H10.0934C12.298 0 14.0914 1.79333 14.0914 3.99867V8.78333C14.0914 10.988 12.298 12.782 10.0934 12.782Z",
    fill: "#2D3958"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4548 4.02539H3.85547C3.57947 4.02539 3.35547 3.80139 3.35547 3.52539C3.35547 3.24939 3.57947 3.02539 3.85547 3.02539H7.4548C7.7308 3.02539 7.9548 3.24939 7.9548 3.52539C7.9548 3.80139 7.7308 4.02539 7.4548 4.02539Z",
    fill: "#2D3958"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3e6ac2d2c463d7aeb19b26e83bf6e109.svg";
export { ForwardRef as ReactComponent };